import React from 'react';

import { MovixButton } from '~/src/features/movix-new/styled';
import * as ST from './styled';

const WatchWithFamily = (): JSX.Element => {
    return (
        <ST.Wrapper>
            <ST.TextBlock>
                <ST.Title>
                    <h2>
                        Смотрите всей семьёй
                        <br/>
                        там, где вам удобно
                    </h2>
                </ST.Title>
                <ST.Description>
                    С&nbsp;бесплатным приложением Movix для iOS, Android,&nbsp;
                    Smart TV или при регистрации на movix.ru
                </ST.Description>
                <ST.ButtonsBlock>
                    <ST.ButtonBlock>
                        <a href={'https://play.google.com/store/apps/details?id=com.ertelecom.agent&hl=ru'} target='_blank' rel='noreferrer'>
                            <MovixButton
                                bType={'secondary'}
                            >
                                Скачать для Android
                            </MovixButton>
                        </a>
                    </ST.ButtonBlock>
                    <ST.ButtonBlock>
                        <a href={'https://apps.apple.com/ru/app/dom-ru-agent/id799358248?mt8'} target='_blank' rel='noreferrer'>
                            <MovixButton
                                bType='secondary'
                            >
                                Скачать для iOS
                            </MovixButton>
                        </a>
                    </ST.ButtonBlock>
                </ST.ButtonsBlock>
            </ST.TextBlock>
            <ST.ImageBlock>
                <ST.TvImage alt='тв приставка мувикс'/>
            </ST.ImageBlock>
        </ST.Wrapper>
    );
};

export default WatchWithFamily;
